import { Link } from "react-router-dom"
import contact from "../../contact.png"

export default function ContactUs() {
    return (
        <section className="my-5 py-5">
            <div className="container">
                <div className="well well-sm"></div>
                <div className="row">
                    <div className="col-md-7">
                        <img src={contact} alt="contact" title="Contact-us" className="w-9/12 mx-auto lg:w-full" />
                    </div>
                    <div className="col-md-5">
                        <h3 className="contact-me text-4xl pb-2 "><strong>Contact Me</strong></h3>
                        <h1 className="text-1xl pb-2">Please fill the form and descibe you project needs and i'll contact as soon as possible</h1>
                        <form>
                            <div className="form-group">
                                <input type="text" className="form-control" placeholder="Name"/>
                            </div>
                            <div className="form-group">
                                <input type="email" className="form-control" placeholder="Email"/>
                            </div>
                            <div className="form-group">
                                <input type="tel" className="form-control" placeholder="Phone"/>
                            </div>
                            <div className="form-group">
                                <textarea className="form-control" cols="30" rows="3" placeholder="Message"/>
                            </div>
                            <div className="mt-2">
                                <Link to="/" className="btn btn-outline-primary m-0  ">
                                    <ion-icon  name="paper-plane"/>&nbsp;SEND
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}
